const CHANNEL_NAME = "rusa_session_channel";

let channel = null;
let myLoginTime = null;

export const initSessionManager = (onForcedLogout) => {
  if (channel) return;

  channel = new BroadcastChannel(CHANNEL_NAME);

  // Get my login time
  myLoginTime = sessionStorage.getItem("loginTime");

  // Listen for new login from other tabs
  channel.onmessage = (event) => {
    if (event.data?.type === "NEW_LOGIN") {

      const latestLoginTime = event.data.loginTime;

      console.log("📩 Latest login time:", latestLoginTime);
      console.log("🕒 My login time:", myLoginTime);

      // If my login is older → mark expired
      if (myLoginTime && myLoginTime < latestLoginTime) {
        sessionStorage.setItem("expired", "true");
      }
    }
  };

  // When tab becomes active → check expiry
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      const expired = sessionStorage.getItem("expired");

      if (expired === "true") {
        console.warn("⚠️ Session expired. Logging out...");
        onForcedLogout();
      }
    }
  });
};

export const broadcastNewLogin = () => {
  const loginTime = Date.now().toString();

  sessionStorage.setItem("loginTime", loginTime);
  sessionStorage.removeItem("expired");

  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }

  channel.postMessage({
    type: "NEW_LOGIN",
    loginTime,
  });
};

export const destroySessionManager = () => {
  if (channel) {
    channel.close();
    channel = null;
  }
};